/**
 * Who may change tenant settings (the studio timezone — WSRADM-0047).
 *
 * Mirrors wsr-api's tenant-settings @PreAuthorize gate
 * (OWNER, ADMIN, SUPER_ADMIN — never STAFF). Keep the two in step: if the server
 * gate changes, change this set, not a call site.
 */
export const TENANT_SETTINGS_WRITE_ROLES: readonly string[] = ['OWNER', 'ADMIN', 'SUPER_ADMIN'];

export function canEditTenantSettings(roles: readonly string[] | undefined): boolean {
  if (!roles) return false;
  return roles.some((role) => TENANT_SETTINGS_WRITE_ROLES.includes(role));
}
